module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "title",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("The Reluctant Swordsman")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("The Seventh Sword Series: Book One")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Dave Duncan")]), _vm._v(" "), _c('p', {
    staticClass: "colophon _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "em"
  }, [_vm._v("The Seventh Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("is fondly dedicated to")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("JENNI and JUDY")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("who had patience, love, and understanding")]), _vm._v(" "), _c('p', {
    staticClass: "center _idGenParaOverride-1"
  }, [_vm._v("for a father with such strange unworldly ideas.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68915c80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReluctantSwordsman.vue
// module id = 66
// module chunks = 0